class EventBus {
  constructor() {
    this.listeners = {};
  }

  // Replaces 'addEventListener' with 'on', 'removeEventListener' with 'off', and 'dispatchEvent' with 'emit'
  // Usage: eventBus.on('qty:change', (data) => console.log(data)); eventBus.emit('qty:change', { value: 1, sectionId: 1 });
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set();
    }
    this.listeners[event].add(callback);
  }

  off(event, callback) {
    if (!this.listeners[event]) return;
    this.listeners[event].delete(callback);
  }

  emit(event, data) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach(callback => callback(data));
  }
}

// Creating a single instance and attaching it to the window object
window.eventBus = new EventBus();



$(".copy-moudle-button").click(function() {
    // 获取要复制的折扣代码
    const discountCode = $(".copy-moudle-discount").text();
    
    navigator.clipboard.writeText(discountCode)
        .then(() => {
            console.log('文本已复制: ' + discountCode);
            
            // 显示成功提示并隐藏复制按钮
            $(".copy_code__succes").removeClass('hidden').show();
            $(".copy_code_btn").hide();
            
            // 三秒后恢复按钮和隐藏成功提示
            setTimeout(() => {
                $(".copy_code__succes").hide();
                $(".copy_code_btn").show();
            }, 3000);
        })
        .catch(err => {
            console.error('复制失败', err);
        });
});